import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { Page, PageHeader } from '../ui'
import { MilitaryHearingLossLeadTracker as LeadTrackerView } from '../components/views/militaryHearingLossView/MilitaryHearingLossLeadTracker/MilitaryHearingLossLeadTracker'

function MilitaryHearingLossLeadTracker() {
    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <Page>
                    <PageHeader eyebrow="Military Hearing Loss" title="Overview" />
                    <LeadTrackerView />
                </Page>
            </MainView>
        </div>
    )
}

export default MilitaryHearingLossLeadTracker
